import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import {
  faUserPlus,
  faFileImport,
  faMoneyCheckDollar,
  faMapLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const actions = [
  {
    labelKey: "quick_actions.invite",
    icon: faUserPlus,
    target: "/users/new",
    color: "primary", // biru
  },
  {
    labelKey: "quick_actions.import",
    icon: faFileImport,
    target: "/users/import",
    color: "success", // hijau
  },
  {
    labelKey: "quick_actions.payroll",
    icon: faMoneyCheckDollar,
    target: "/payroll/create",
    color: "warning", // kuning/oranye
  },
  {
    labelKey: "quick_actions.location",
    icon: faMapLocationDot,
    target: "/attendance?tab=locations",
    color: "info", // biru muda
  },
];

export default function QuickActions() {
  const navigate = useNavigate();
  const { t } = useTranslation("dashboard");

  return (
    <div className="row g-3">
      {actions.map((action, index) => (
        <div className="col-sm-6 col-lg-3 d-flex" key={index}>
          {/* Kartu putih dengan ikon berwarna; tinggi seragam & label rata kiri (dashboard.css). */}
          <button
            type="button"
            onClick={() => navigate(action.target)}
            className={`qa-btn qa-btn--${action.color}`}
            title={t(action.labelKey)}
          >
            <span className="qa-btn__icon" aria-hidden="true">
              <FontAwesomeIcon icon={action.icon} />
            </span>
            <span className="qa-btn__label">{t(action.labelKey)}</span>
          </button>
        </div>
      ))}
    </div>
  );
}
